import { Actions } from '../../interfaces'
import { Year } from '@/entities/vehicle'

import find from './find'

export const actions: Actions = {
  find,
}

export default {
  Model: { Year },
  actions: { [Year.name]: actions },
}
